import { render, staticRenderFns } from "./activateInfo.vue?vue&type=template&id=2a808f6c&scoped=true&"
import script from "./activateInfo.vue?vue&type=script&lang=js&"
export * from "./activateInfo.vue?vue&type=script&lang=js&"
import style0 from "./activateInfo.vue?vue&type=style&index=0&id=2a808f6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a808f6c",
  null
  
)

export default component.exports